// @flow
import { createAction, handleActions } from 'redux-actions';
import { fromJS } from 'immutable';
import handleReduce from '~/core/state/handle-reduce';

const NAVIGATE = 'hive/navigate/NAVIGATE';
const RESET_NAVIGATE = 'hive/navigate/RESET';

export const navigate = createAction(NAVIGATE);
export const resetNavigate = createAction(RESET_NAVIGATE);

export default handleActions(
    {
        // $FlowFixMe
        [NAVIGATE]: handleReduce((state, { payload }) => state.set('path', payload).set('shouldRedirect', true)),
        // $FlowFixMe
        [RESET_NAVIGATE]: handleReduce(state => state.set('path', '').set('shouldRedirect', false))
    },
    fromJS({
        path: '',
        shouldRedirect: false
    })
);



// WEBPACK FOOTER //
// ./src/core/state/navigate/index.js